import { createSelector } from '@ngrx/store'
import { RootState } from '../../root.model'
import { MetricsRedux } from './metrics.reducer'

const selectHeliosMetrics = (state: RootState) => state.helios.metrics

export const selectExtTxDataAvailableTimes = createSelector(
  selectHeliosMetrics,
  (state: MetricsRedux) => state.sessionExtTxDataAvailableTimes,
)

export const selectSessionStartTimes = createSelector(
  selectHeliosMetrics,
  (state: MetricsRedux) => state.sessionStartTimes,
)

export const selectCwTxDataAvailableTimes = createSelector(
  selectHeliosMetrics,
  (state: MetricsRedux) => state.sessionCwTxDataAvailableTimes,
)

export const selectPositionsDataAvailableTimes = createSelector(
  selectHeliosMetrics,
  (state: MetricsRedux) => state.sessionPositionDataAvailableTimes,
)
